import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Cookies } from "react-cookie";

export const ModalThongBaoApp = (props) => {
    const cookies = new Cookies();

    const dongthongbao = () => {
        var d = new Date();
        d.setTime(d.getTime() + 12 * 60 * 60 * 1000);
        cookies.set('noshowapp', "1", { path: '/', expires: d });
        props.setIsThongBaoApp(false);
    }

    const linkappchplay = () => {
        window.location.href = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.morman2021";
        dongthongbao();
    }



    return (
        <Modal
            {...props}
            size="modal-dialog modalNewApp"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left popup-detail "
            backdrop="static"
            style={{ borderRadius: 10 }}
        >
            <Modal.Body className="modalThongBao" style={{ padding: 0, borderRadius: 10 }}>
                <div style={{ textAlign: "center", borderRadius: "10px" }}>
                    {props.nameapp === "Android" && (
                        <>
                            <div style={{ color: "#000000", textAlign: "center", padding: 10 }} >
                                <span style={{ fontSize: "18px" }} > Morman đã có App trên mobile.</span>
                                <br />
                                Mở app Morman trải nghiệm ngay!
                            </div>
                            <div style={{ width: "100%", margin: "0px" }} >
                                <div className="modalThongBaoButonAndoird1">
                                    <a href={() => false} onClick={linkappchplay}>
                                        Mở CHPlay
                                    </a>
                                    {/* <button type="button" onclick="linkappchplay()" data-dismiss="modal" aria-label="Close" style="background: none; border: 0px; color: #FFF;">
                                        Mở CHPlay
                                    </button> */}
                                </div>
                                <div className="modalThongBaoButonAndoird2">
                                    <a href={() => false} onClick={dongthongbao}>
                                        Bỏ qua
                                    </a>
                                </div>
                            </div>
                        </>
                    )}
                    {props.nameapp === "iOS" && (
                        <>
                            <div style={{ color: "#000000", textAlign: "center", padding: 10 }} >
                                <span style={{ fontSize: "18px" }} > Morman đã có App trên mobile.</span>
                                <br />
                                Liên hệ đến số <a href="tel:0903285356">0903285356</a> để được hỗ trợ sử dụng!
                            </div>
                            <div className="modalThongbaoButoniOS">
                                <a href={() => false} onClick={dongthongbao}>
                                    Bỏ qua
                                </a>
                            </div>
                        </>
                    )}

                </div>
            </Modal.Body>
        </Modal >
    );
};
